<template>
  <modal class="success-dialog" redesign :show-modal-close="false" @close="close">
    <div slot="body" class="column">
      <div class="icon"><img src="/static/images/elements/icon_big_ok.svg" /><br /></div>
      <div class="text">
        <h3>{{ $tr('invites.invite.invitesSent') }}</h3>
      </div>
    </div>
    <div slot="footer">
      <vbutton class="button-ok" label="common.ok" @click="routeToList" />
    </div>
  </modal>
</template>

<script>
  import Modal from '@/components/Modal.vue'

  export default {
    name: 'invites-creation-creationSuccessModal',

    components: {
      Modal
    },

    methods: {
      close () {
        this.$router.push(this.listRoute)
      },

      routeToList () {
        this.$store.dispatch('invites/creation/resetState')
        this.close()
      }
    },

    computed: {
      listRoute () {
        return {
          name: 'invites'
        }
      }
    },

    mounted () {
      this.$store.dispatch('invites/fetch')
    }
  }
</script>

<style lang="scss" scoped>
@import '@/styles/colors.scss';

.success-dialog {
  .column {
    display: flex;
    flex-direction: column;
    align-items: center;

    .text {
      width: 100%;
      text-align: center;
      margin: 33px 0 16px;

      h3 {
        margin: 0;
      }

      ul {
        list-style: none;

        li {
          color: $text-color;
        }
      }
    }
  }

  .modal-footer .vcv-button {
    margin: 0 auto !important;
  }
}

.button-ok {
  min-width: 100px;
}
</style>
